import * as React from "react"

const EditTaggedDateIcon = (props) => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M16.275 10.0125L15.525 10.7625L13.9875 9.2625L14.7375 8.5125C14.8875 8.355 15.1425 8.3475 15.315 8.5125L16.275 9.4725C16.4175 9.6225 16.4175 9.8625 16.275 10.0125ZM9 14.205V15.75H10.545L15.09 11.16L13.5525 9.66L9 14.205ZM3.75 14.25H7.5V15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 2.925 2.925 2.25 3.75 2.25H4.5V0.75H6V2.25H12V0.75H13.5V2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V6.75H3.75V14.25ZM3.75 3.75V5.25H14.25V3.75H3.75Z"
			fill="#3476E4"
		/>
	</svg>
)

export default EditTaggedDateIcon
